import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { verifyToken } from "../services/authService";
import { triggerSessionExpired } from "../context/SessionContext";

export const useAuth = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem("accessToken");

      if (location.pathname === "/login") return;

      if (!token) {
        if (sessionStorage.getItem("hadSession")) {
          triggerSessionExpired();
        }
        navigate("/login");
        return;
      }

      try {
        const payload = JSON.parse(atob(token.split(".")[1]));
        const expiresAt = payload.exp * 1000;

        if (Date.now() >= expiresAt) {
          localStorage.removeItem("accessToken");
          localStorage.removeItem("refreshToken");

          sessionStorage.setItem("hadSession", "1");
          triggerSessionExpired();

          navigate("/login");
          return;
        }

        await verifyToken(token);

        sessionStorage.setItem("hadSession", "1");
      } catch (error) {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");

        sessionStorage.setItem("hadSession", "1");
        triggerSessionExpired();

        navigate("/login");
      }
    };

    checkAuth();
  }, [navigate, location.pathname]);
};
